module.exports = __webpack_public_path__ + "static/img/回放.aa6306f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/回放.png
// module id = rNBc
// module chunks = 1